import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/macro';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Heading2 } from 'uikit/Heading';

import {
  getL3PathBySlug,
  relatedOrdersQuery,
  RelatedServices,
  RelatedServicesResponse,
} from './RegisterRelatedOrders.helpers';
import './RegisterRelatedOrders.scss';

type Props =
  | {
      l3Slug: string;
    }
  | {
      services: RelatedServices;
    };

const RegisterRelatedOrders: FC<Props> = (props) => {
  const slug = 'l3Slug' in props && props.l3Slug;
  const { data } = useQuery<RelatedServicesResponse>(relatedOrdersQuery, {
    variables: { slug },
    skip: !slug,
  });

  const relatedServices = 'services' in props && props.services;

  if (!data && !relatedServices) return null;

  const items = data ? data.l3BySlug.relatedServices : relatedServices;
  if (!items) return null;

  return (
    <section id="related-orders" className="registerRelatedOrders">
      <div className="container">
        <Heading2>
          <Trans>Powiązane zlecenia</Trans>
        </Heading2>
        <ul className="registerRelatedOrders__items">
          {items.map((item) => (
            <li className="registerRelatedOrders__item" key={`category-${item.id}`}>
              <Link to={getL3PathBySlug(item.slug)} className="registerRelatedOrders__link">
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RegisterRelatedOrders;
